"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _react = _interopRequireWildcard(require("react"));

var _reactAutobind = _interopRequireDefault(require("react-autobind"));

var _RadioSelectorButton = _interopRequireDefault(require("./RadioSelectorButton"));

var RadioSelector =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(RadioSelector, _PureComponent);

  function RadioSelector(props) {
    var _this;

    (0, _classCallCheck2.default)(this, RadioSelector);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(RadioSelector).call(this, props));
    (0, _reactAutobind.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)));
    _this.state = {
      value: _this.props.value
    };
    return _this;
  }

  (0, _createClass2.default)(RadioSelector, [{
    key: "onClick",
    value: function onClick(value) {
      var onClick = this.props.onClick;
      this.setState({
        value: value
      });
      onClick && onClick(value);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          buttonStyle = _this$props.buttonStyle,
          children = _this$props.children,
          displayCheckmark = _this$props.displayCheckmark;
      var value = this.state.value; // TODO: This could be a good use case for react context https://hackernoon.com/how-do-i-use-react-context-3eeb879169a2

      var options = _react.default.Children.map(children, function (option) {
        return _react.default.createElement(_RadioSelectorButton.default, Object.assign({
          onClick: _this2.onClick,
          selected: option.props.value === value,
          style: buttonStyle,
          displayCheckmark: displayCheckmark
        }, option.props));
      });

      return _react.default.createElement("div", null, options);
    }
  }]);
  return RadioSelector;
}(_react.PureComponent);

RadioSelector.defaultProps = {
  displayCheckmark: true
};
var _default = RadioSelector;
exports.default = _default;